// extracted by mini-css-extract-plugin
export default {"container":"_2-HQY","titleDefault":"_3LgiP","titleLarge":"OstSk","titleBold":"_1mwTh","content":"MpqUZ","contentNoPadding":"_7BV2_"};